import React from 'react';
import { img_logo } from '../../assets';

/**
 * SiteLoading component is used to display the a full screen loading screen
 * showing that the website is loading.
 */
export default function SiteLoading() {
  return (
    <div className="container h-100vh d-flex justify-content-center align-items-center flex-column">
      <img src={img_logo} alt="" className="img-fluid" width={300} />
      <div className="d-flex justify-content-center align-items-center mt-5 gap-3 text-primary">
        {[1, 2, 3].map((i) => (
          <div className="spinner-grow" key={i}></div>
        ))}
      </div>
    </div>
  );
}
